import { Injectable } from '@angular/core';
import {PaginationModel, ProductCollectionModel, RequestParamModel} from "@coreModels";
import {catchError, map, Observable, throwError} from "rxjs";
import {ApiConstants} from "@coreConstant";
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductCollectionService {

  /**
   * Constructor for the class which initializes the service dependency.
   * @return {void}
   */
  constructor(private http: HttpClient) { }

  /**
   * Fetches the list of product collections based on the provided request parameters.
   *
   * @param {RequestParamModel} requestParamModel - The parameters to be sent with the API request.
   * @*/
  getCollections(requestParamModel: RequestParamModel): Observable<any> {
    return this.http.get(ApiConstants.PRODUCT_COLLECTION_LISTS_URL + requestParamModel.getParams(), { observe: 'response' })
      .pipe(map((response: any) => {
        const productList = new PaginationModel<any>();
        const headers = response.headers;
        productList.setHeaders(headers);
        productList.data = response.body.data as any[];
        return productList;
      }), catchError((err: unknown) => {
        return throwError(() => err);
      }));
  }
}
